/**
 * Best grade per level, kept in this browser only. Storage can be missing or
 * throw (private mode, blocked site data), so every access degrades to "none".
 */
const KEY = "clerk.best.v1";
const RANK = ["A", "B", "C", "D"];

function load(): Record<string, string> {
  try {
    const raw = localStorage.getItem(KEY);
    const v: unknown = raw ? JSON.parse(raw) : null;
    return typeof v === "object" && v !== null ? (v as Record<string, string>) : {};
  } catch {
    return {};
  }
}

export function bestGrade(levelId: string): string | null {
  const g = load()[levelId];
  return typeof g === "string" && RANK.includes(g) ? g : null;
}

/** Keep the better of the stored and the new grade. */
export function recordGrade(levelId: string, grade: string): void {
  if (!RANK.includes(grade)) return;
  const all = load();
  const prev = all[levelId];
  if (prev && RANK.includes(prev) && RANK.indexOf(prev) <= RANK.indexOf(grade)) return;
  all[levelId] = grade;
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* not persisted; fine */
  }
}

const TAB_KEY = "clerk.dept.v1";

export function lastDept(): string | null {
  try {
    return localStorage.getItem(TAB_KEY);
  } catch {
    return null;
  }
}

export function rememberDept(id: string): void {
  try {
    localStorage.setItem(TAB_KEY, id);
  } catch {
    /* not persisted; fine */
  }
}

/** Close-ups with a real (pixelated) image: show it, or the hand-drawn version. */
export type Imagery = "photo" | "drawn";
const IMG_KEY = "clerk.imagery.v1";
let imagery: Imagery | null = null;

export function getImagery(): Imagery {
  if (imagery) return imagery;
  try {
    imagery = localStorage.getItem(IMG_KEY) === "drawn" ? "drawn" : "photo";
  } catch {
    imagery = "photo";
  }
  return imagery;
}

export function setImagery(v: Imagery): void {
  imagery = v;
  try {
    localStorage.setItem(IMG_KEY, v);
  } catch {
    /* not persisted; fine */
  }
}
